module.exports = __webpack_public_path__ + "static/desktop/img/faq-book-right.99200011.jpg";